import { mergeWith, isArray, isObject } from 'lodash';

/**
 * Deep merge formData with submitData for save operations.
 *
 * Array strategy: uses submitData array length (user adds/removes respected),
 * each element shallow-merged with corresponding formData element (preserves
 * metadata like _id, metricIds, inverted, min, max).
 *
 * Object strategy: standard lodash deep merge (preserves nested fields like
 * traceRoute.target, traceRoute.port).
 *
 * @param {Object} formData - Original persisted form data
 * @param {Object} submitData - RHF getValues() output (may be incomplete)
 * @returns {Object} Deep-merged data safe for save
 */
export function deepMergeForSave(formData, submitData) {
    return mergeWith({}, formData, submitData, (objValue, srcValue) => {
        if (isArray(srcValue)) {
            return srcValue.map((item, index) => {
                if (isObject(item) && !isArray(item) && isObject(objValue?.[index]) && !isArray(objValue?.[index])) {
                    return { ...objValue[index], ...item };
                }
                return item;
            });
        }
        // Return undefined for non-array values to use default deep merge behavior
    });
}
